export const useConvertStylePropsToString = (styleProps: {
  [key: string]: string;
}) => {
  return ` style="font-family: 'Times New Roman', serif; ${Object.entries(styleProps)
    .map(([key, value]) => `${key}: ${value}`)
    .join("; ")}"`;
};
